
export const blogArticles = [
  {
    id: 'como-vender-coche-siniestrado-gava',
    category: 'Guías Prácticas',
    title: 'Cómo Vender un Coche Siniestrado en Gavá: Guía Completa 2025',
    excerpt: 'Descubre paso a paso cómo vender tu coche siniestrado en Gavá al mejor precio. Te explicamos los documentos necesarios, cómo obtener la mejor valoración y por qué elegir un desguace profesional en Gavá para la venta de tu vehículo accidentado.',
    image: 'https://public.readdy.ai/ai/img_res/ceedd57cbb39ff43d0a41a618da2b6ac.jpg',
    author: 'Equipo Desguace Gavá',
    date: '12 Ene 2025',
    readTime: '8 min',
    featured: true,
    tags: ['vender coche siniestrado', 'desguace Gavá', 'coches accidentados'],
  },
  {
    id: 'documentacion-baja-vehiculo-gava',
    category: 'Normativas',
    title: 'Documentación para Dar de Baja un Vehículo en Gavá: Todo lo que Necesitas',
    excerpt: 'Conoce todos los trámites y documentos necesarios para dar de baja tu coche en Gavá. Desde el certificado de destrucción hasta la baja definitiva en la DGT, te explicamos cada paso del proceso administrativo.',
    image: 'https://readdy.ai/api/search-image?query=official%20car%20documents%20paperwork%20on%20desk%20with%20car%20keys%20professional%20office%20setting%20warm%20lighting%20clean%20organized%20workspace%20automotive%20documentation%20editorial%20style&width=800&height=500&seq=blog-art-002&orientation=landscape',
    author: 'Equipo Desguace Gavá',
    date: '8 Ene 2025',
    readTime: '6 min',
    featured: false,
    tags: ['baja vehículo', 'documentación', 'DGT Gavá'],
  },
  {
    id: 'precio-coche-chatarra-gava-2025',
    category: 'Precios',
    title: '¿Cuánto Pagan por un Coche para Chatarra en Gavá en 2025?',
    excerpt: 'Analizamos los precios actuales que se pagan por coches para chatarra en Gavá y el Baix Llobregat. Factores que influyen en la valoración, cómo conseguir el mejor precio y comparativa entre desguaces de la zona.',
    image: 'https://readdy.ai/api/search-image?query=euro%20money%20bills%20and%20coins%20on%20table%20next%20to%20miniature%20car%20model%20financial%20concept%20clean%20white%20background%20professional%20product%20photography%20warm%20studio%20lighting%20editorial%20style&width=800&height=500&seq=blog-art-003&orientation=landscape',
    author: 'Equipo Desguace Gavá',
    date: '5 Ene 2025',
    readTime: '7 min',
    featured: false,
    tags: ['precio chatarra', 'valoración coche', 'desguace Gavá'],
  },
  {
    id: 'reciclaje-vehiculos-medio-ambiente-gava',
    category: 'Sostenibilidad',
    title: 'Reciclaje de Vehículos en Gavá: Impacto Ambiental y Beneficios',
    excerpt: 'El reciclaje de coches en Gavá es fundamental para el medio ambiente. Descubre cómo los desguaces profesionales contribuyen a la economía circular, qué piezas se reciclan y cómo reducimos la huella de carbono en el Baix Llobregat.',
    image: 'https://readdy.ai/api/search-image?query=green%20recycling%20symbol%20with%20car%20parts%20eco%20friendly%20automotive%20recycling%20concept%20nature%20background%20with%20industrial%20elements%20clean%20modern%20environmental%20photography%20editorial%20style&width=800&height=500&seq=blog-art-004&orientation=landscape',
    author: 'Equipo Desguace Gavá',
    date: '28 Dic 2024',
    readTime: '5 min',
    featured: false,
    tags: ['reciclaje coches', 'medio ambiente', 'economía circular Gavá'],
  },
  {
    id: 'piezas-segunda-mano-gava-ventajas',
    category: 'Piezas',
    title: 'Ventajas de Comprar Piezas de Segunda Mano en Desguaces de Gavá',
    excerpt: 'Las piezas de segunda mano de desguaces en Gavá ofrecen una alternativa económica y ecológica. Te contamos las ventajas, cómo verificar su calidad y dónde encontrar los mejores recambios para tu vehículo en la comarca.',
    image: 'https://readdy.ai/api/search-image?query=organized%20auto%20spare%20parts%20on%20clean%20shelves%20in%20modern%20warehouse%20car%20engine%20components%20brake%20discs%20headlights%20professional%20automotive%20parts%20storage%20warm%20industrial%20lighting%20editorial%20photography&width=800&height=500&seq=blog-art-005&orientation=landscape',
    author: 'Equipo Desguace Gavá',
    date: '20 Dic 2024',
    readTime: '6 min',
    featured: false,
    tags: ['piezas segunda mano', 'recambios', 'desguace Gavá'],
  },
  {
    id: 'retirada-coches-abandonados-gava',
    category: 'Servicios',
    title: 'Retirada de Coches Abandonados en Gavá: Servicio Gratuito de Grúa',
    excerpt: '¿Tienes un coche abandonado en Gavá que necesitas retirar? Te explicamos cómo funciona nuestro servicio gratuito de grúa, los requisitos legales y cómo gestionar la retirada de vehículos abandonados en el Baix Llobregat.',
    image: 'https://readdy.ai/api/search-image?query=professional%20tow%20truck%20carrying%20old%20car%20on%20flatbed%20modern%20recovery%20vehicle%20on%20clean%20road%20daytime%20urban%20setting%20professional%20automotive%20photography%20warm%20natural%20lighting%20editorial%20style&width=800&height=500&seq=blog-art-006&orientation=landscape',
    author: 'Equipo Desguace Gavá',
    date: '15 Dic 2024',
    readTime: '5 min',
    featured: false,
    tags: ['retirada coches', 'grúa gratis', 'coches abandonados Gavá'],
  },
  {
    id: 'seguro-coche-siniestro-total-gava',
    category: 'Seguros',
    title: 'Siniestro Total del Seguro: Qué Hacer con tu Coche en Gavá',
    excerpt: 'Cuando el seguro declara siniestro total tu vehículo en Gavá, tienes varias opciones. Te explicamos cómo funciona la indemnización, si puedes quedarte con el coche, y cómo sacar el máximo beneficio vendiendo los restos al desguace.',
    image: 'https://readdy.ai/api/search-image?query=car%20insurance%20claim%20document%20with%20damaged%20vehicle%20in%20background%20professional%20office%20desk%20with%20insurance%20papers%20pen%20and%20calculator%20warm%20natural%20lighting%20clean%20modern%20setting%20editorial%20photography%20style&width=800&height=500&seq=blog-art-007&orientation=landscape',
    author: 'Equipo Desguace Gavá',
    date: '18 Ene 2025',
    readTime: '9 min',
    featured: false,
    tags: ['siniestro total', 'seguro coche', 'indemnización Gavá'],
  },
  {
    id: 'cuando-no-merece-reparar-coche-gava',
    category: 'Mecánica',
    title: '¿Cuándo No Merece la Pena Reparar tu Coche? Señales Clave en 2025',
    excerpt: 'A veces reparar un coche viejo en Gavá sale más caro que venderlo al desguace. Te damos las claves para saber cuándo es mejor dejar de invertir en reparaciones y vender tu vehículo a un desguace profesional.',
    image: 'https://readdy.ai/api/search-image?query=mechanic%20inspecting%20old%20car%20engine%20in%20professional%20garage%20workshop%20with%20tools%20and%20diagnostic%20equipment%20warm%20industrial%20lighting%20clean%20organized%20automotive%20repair%20shop%20editorial%20photography%20style&width=800&height=500&seq=blog-art-008&orientation=landscape',
    author: 'Equipo Desguace Gavá',
    date: '20 Ene 2025',
    readTime: '7 min',
    featured: false,
    tags: ['reparar coche', 'mecánica', 'desguace Gavá'],
  },
  {
    id: 'transferencia-vehiculo-desguace-legal-gava',
    category: 'Legal',
    title: 'Aspectos Legales de Vender tu Coche a un Desguace en Gavá',
    excerpt: 'Vender un coche a un desguace en Gavá implica obligaciones legales que debes conocer. Desde la transferencia de titularidad hasta la responsabilidad civil, te explicamos todo para que la venta sea segura y sin problemas.',
    image: 'https://readdy.ai/api/search-image?query=legal%20contract%20signing%20with%20car%20keys%20on%20professional%20desk%20lawyer%20office%20with%20bookshelves%20in%20background%20warm%20ambient%20lighting%20clean%20modern%20legal%20office%20setting%20editorial%20photography%20style&width=800&height=500&seq=blog-art-009&orientation=landscape',
    author: 'Equipo Desguace Gavá',
    date: '22 Ene 2025',
    readTime: '8 min',
    featured: false,
    tags: ['legal desguace', 'transferencia vehículo', 'responsabilidad civil Gavá'],
  },
  {
    id: 'indemnizacion-seguro-accidente-gava',
    category: 'Seguros',
    title: 'Cómo Negociar la Indemnización del Seguro tras un Accidente en Gavá',
    excerpt: 'Tras un accidente de tráfico en Gavá, la indemnización del seguro puede ser insuficiente. Te enseñamos a negociar con la aseguradora, qué documentos presentar y cómo complementar la indemnización vendiendo el coche al desguace.',
    image: 'https://readdy.ai/api/search-image?query=car%20accident%20aftermath%20with%20insurance%20adjuster%20taking%20notes%20clipboard%20professional%20assessment%20damaged%20vehicle%20on%20road%20daytime%20urban%20setting%20warm%20natural%20lighting%20editorial%20photography%20style&width=800&height=500&seq=blog-art-010&orientation=landscape',
    author: 'Equipo Desguace Gavá',
    date: '25 Ene 2025',
    readTime: '10 min',
    featured: false,
    tags: ['indemnización seguro', 'accidente tráfico', 'negociar aseguradora Gavá'],
  },
  {
    id: 'averias-caras-coche-viejo-gava',
    category: 'Mecánica',
    title: 'Las 10 Averías Más Caras en Coches Viejos: ¿Reparar o Desguazar en Gavá?',
    excerpt: 'Motor fundido, caja de cambios rota, catalizador dañado... Algunas averías cuestan más que el propio coche. Analizamos las 10 reparaciones más caras y cuándo es mejor vender tu coche al desguace en Gavá.',
    image: 'https://readdy.ai/api/search-image?query=close%20up%20of%20broken%20car%20engine%20with%20visible%20damage%20cracked%20parts%20and%20worn%20components%20in%20professional%20mechanic%20workshop%20warm%20industrial%20lighting%20detailed%20automotive%20photography%20editorial%20style&width=800&height=500&seq=blog-art-011&orientation=landscape',
    author: 'Equipo Desguace Gavá',
    date: '28 Ene 2025',
    readTime: '9 min',
    featured: false,
    tags: ['averías caras', 'coche viejo', 'desguazar Gavá'],
  },
  {
    id: 'herencia-coche-fallecido-desguace-gava',
    category: 'Legal',
    title: 'Coche Heredado en Gavá: Cómo Venderlo al Desguace sin Complicaciones',
    excerpt: 'Heredar un coche en Gavá que no necesitas puede ser un problema. Te explicamos los trámites de aceptación de herencia, cambio de titularidad y cómo vender un vehículo heredado al desguace de forma legal y rápida.',
    image: 'https://readdy.ai/api/search-image?query=old%20vintage%20car%20parked%20in%20residential%20garage%20with%20family%20photos%20and%20personal%20items%20around%20nostalgic%20warm%20lighting%20soft%20tones%20clean%20setting%20editorial%20photography%20style%20sentimental%20atmosphere&width=800&height=500&seq=blog-art-012&orientation=landscape',
    author: 'Equipo Desguace Gavá',
    date: '30 Ene 2025',
    readTime: '8 min',
    featured: false,
    tags: ['herencia coche', 'trámites legales', 'desguace Gavá'],
  },
];

export const blogCategories = [
  'Todos',
  'Guías Prácticas',
  'Normativas',
  'Precios',
  'Sostenibilidad',
  'Piezas',
  'Servicios',
  'Seguros',
  'Mecánica',
  'Legal',
];
